// extracted by mini-css-extract-plugin
export default {"container":"yw3_BN","priceContainer":"xhSDbE","quantityContainer":"LpbNWm"};